import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Input } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'xs',
  };

  handleClickOpen = () => { this.setState({ open: true, voucher: this.props.voucher }); };

  handleClose = () => { this.setState({ open: false }); };

  handleMaxWidthChange = event => { this.setState({ maxWidth: event.target.value }); };

  handleFullWidthChange = event => { this.setState({ fullWidth: event.target.checked }); };

  onChangeHandle = (type) => (f, { value }) => {
    if(this.props.receiptedit == 'none') {
      alert('Access is Denied!!!');
      return;
    }
    this.setState({ [type]: value })
  }

  submit = () => {
    let context = this;
    let id = this.props.id;
    let voucher = this.state.voucher;
    let data = { 'id': id, 'voucher': voucher };
    this.setState({ load: true, message: 'Updating Voucher!!!' });
    $.ajax({
      type: 'POST', data, url: Server() + 'receipt/updatevoucher.php',
      success: function(data) {
        if (data == 1) {
          let datas = context.props.data;
          datas.map((x) => {
            if (x.id == id) {
              x.voucher = voucher;
            }
          })
          context.props.updateData(datas);
          context.setState({ voucher: '', open: false, load: false })
        }
        else {
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
        <div onClick={this.handleClickOpen} style={{ cursor: 'pointer' }}>{this.props.voucher}</div>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Edit Voucher</DialogTitle>
          <DialogContent>
            Voucher No<br/>
            <Input onChange={this.onChangeHandle('voucher')} value={this.state.voucher} focus fluid />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit} color="primary">Submit</Button>
            <Button onClick={this.handleClose} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);